// extracted by mini-css-extract-plugin
export default {"SortBtn":"ASaHN4wT","Arrow":"wHPGHakG","Up":"pVNhTONP","Down":"MFNoEGoD","isActive":"RmyAkuJ7"};